import {
  copySVG,
  copyLargeSVG,
  giftPng,
  telegramPng,
  twitterSvg,
  tick,
  whatsappSvg,
} from "../../assets/images";
import "./Refer.css";
import { useContext, useEffect, useState } from "react";
import { referProp, response, shareOnPlatform } from "./Response";
import QuestContext from "../QuestWrapper.tsx";
import PopupComponent from "./Popup.tsx";
import ShareArticle from "../Share/ShareArticle.tsx";
import General, { useGeneral } from "../../general.ts";

export const ReferShare = ({
  isOpen = true,
  questId = "",
  userId = "",
  token = "",
  color,
  bgColor,
  isArticle = false,
  description,
  heading,
  headingColor,
  uniqueEmailId,
  uniqueUserId,
  entityAuthenticationToken
}: referProp) => {
  const [shareCode, setCode] = useState("");
  const [copy, setCopy] = useState(false);
  const { apiKey, apiSecret, entityId, apiType, user } = useContext(QuestContext.Context);
  const style = !!color && !!bgColor ? { color, backgroundColor: bgColor } : {};
  let GeneralFunctions = new General('mixpanel', apiType);
  const general = useGeneral('quest')

  useEffect(() => {
    GeneralFunctions.fireTrackingEvent("quest_refer_share_loaded", "refer_share");
    general.trackEvent(
      'quest-refer-share-loaded',
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    )
    response(questId, {
      apiKey,
      userid: userId,
      entityId,
      apisecret: apiSecret!,
      token,
      apiType
    }).then((r) => setCode(r.referralCode || ""));
  }, []);

  useEffect(() => {
    if (entityId && uniqueUserId) {
      const functions = new General('')
      functions.getExternalLogin({ apiType, uniqueUserId, entityId, userId, apiKey, apiSecret: apiSecret || "", token, uniqueEmailId, entityAuthenticationToken })
    }
  }, [])

  if (isArticle)
    return (<ShareArticle
      questId={questId}
      description={description}
      heading={heading}
      token={token} userId={userId}
    />)
  if (!isOpen) return <></>;
  return (
    <div className="q-referShare" style={style}>
      <div className="q-referShare-content">
        <div className="q-referShare-content-text">
          <div className="q-referShare-content-head" style={style}>
            Invite your friends
          </div>
          <div className="q-referShare-content-para" style={style}>
            Share your unique referral code with friends and receive 10 coins in
            credits each time a friend signs up!
          </div>
          <div className="q-referShare-referralCode">
            <div>Referral code</div>
            <div className="q-referShare-content-rect" style={style}>
              <div style={{ display: "inline", ...style }} className="q-referShare-content-code" >
                {shareCode}
              </div>
              <img
                className="q-referEarn-copy-img"
                onClick={() => {
                  GeneralFunctions.fireTrackingEvent("quest_refer_share_referral_code_copy_button_clicked", "refer_share");
                  navigator.clipboard
                    .writeText(shareCode)
                    .then(() => setCopy(true));
                }}
                src={copy ? tick : copySVG}
                style={{ cursor: "pointer" }}
                width="16px"
                alt="tick"
              />
            </div>
          </div>
          <div className="q-referShare-content-msg">
            <div style={style}>Share with your community</div>
          </div>
          <div className="q-referShare-content-social">
            {/* Twitter */}
            <img
              className="q-referShare-content-social-img"
              onClick={() => {
                GeneralFunctions.fireTrackingEvent("quest_refer_share_twitter_button_clicked", "refer_share");
                shareOnPlatform(shareCode, "twitter")
              }}
              src={twitterSvg}
              alt="Twitter"
            />

            {/* Whatsapp */}
            <img
              className="q-referShare-content-social-img"
              src={whatsappSvg}
              onClick={() => {
                GeneralFunctions.fireTrackingEvent("quest_refer_share_whatsapp_button_clicked", "refer_share");
                shareOnPlatform(shareCode, "whatsapp")
              }}
              alt="Whatsapp"
            />
            <img
              className="q-referShare-content-social-img"
              onClick={() => {
                GeneralFunctions.fireTrackingEvent("quest_refer_share_telegram_button_clicked", "refer_share");
                shareOnPlatform(shareCode, "telegram")
              }}
              src={telegramPng}
              alt="telegramPng"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReferEarn = ({
  questId = "",
  userId = "",
  token = "",
  color = "black",
  bgColor = "white",
  uniqueEmailId,
  uniqueUserId,
  entityAuthenticationToken
}: referProp) => {
  const [shareCode, setCode] = useState("");
  const [copy, setCopy] = useState(false);
  const { apiKey, apiSecret, entityId ,apiType, user } = useContext(QuestContext.Context);
  const [share, setshare] = useState(false);
  const style = !!color && !!bgColor ? { color, backgroundColor: bgColor } : {};

  const general = useGeneral('quest')

  useEffect(() => {
    general.trackEvent(
      'quest-refer-earn-loaded',
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    )
    response(questId, {
      apiKey,
      userid: userId,
      entityId,
      apisecret: apiSecret,
      token,
      apiType
    }).then((r) => setCode(r.referralCode || ""));
  }, []);

  useEffect(() => {
    if (entityId && uniqueUserId) {
      const functions = new General('')
      functions.getExternalLogin({ apiType, uniqueUserId, entityId, userId, apiKey, apiSecret: apiSecret!, token, uniqueEmailId, entityAuthenticationToken })
    }
  }, [])

  return (
    <div className="q-referEarn" style={style}>
      <PopupComponent onClose={() => setshare(false)} isOpen={share}>
        <div className="q-referShare-content-social">
          <div className="q-referEarn-pop-div">
            <img
              className="q-referShare-content-social-img"
              onClick={() => shareOnPlatform(shareCode, "twitter")}
              src={twitterSvg}
              alt="Twitter"
            />
            Twitter
          </div>
          <div className="q-referEarn-pop-div" style={style}>
            <img
              className="q-referShare-content-social-img"
              onClick={() => shareOnPlatform(shareCode, "telegram")}
              src={telegramPng}
              alt="telegramPng"
            />
            Telegram
          </div>
          <div className="q-referEarn-pop-div" style={style}>
            <img
              className="q-referShare-content-social-img"
              src={whatsappSvg}
              onClick={() => shareOnPlatform(shareCode, "whatsapp")}
              alt="Whatsapp"
            />
            Whatsapp
          </div>
        </div>
      </PopupComponent>
      <img src={giftPng} className="q-referEarn-gift-img" alt="giftPng" />
      <div className="q-referEarn-head" style={style}>Your referral code:</div>
      <div className="q-referEarn-para" style={style}>
        Share your referral code with your friends and get benefits.
      </div>
      <div className="q-referEarn-rect">
        <div style={{ display: "inline" }}>{shareCode}</div>
        <img
          className="q-referEarn-copy-img"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigator.clipboard.writeText(shareCode).then(() => setCopy(true));
          }}
          src={copy ? tick : copyLargeSVG}
          width="20px"
          alt="tick"
        />
      </div>
      <button onClick={() => setshare(true)} className="q-referEarn-invite">
        Invite Friends
      </button>
    </div>
  );
};

// export const Refer
